import React from 'react';
import LargeButton from '../shared/components/LargeButton';

/**
 * @typedef {object} IndustryOnlyNotFoundButtonsProps
 * @property {(path: string) => void} [handleBtnClick]
 */

/**
 * @param {IndustryOnlyNotFoundButtonsProps} props
 */
const IndustryOnlyNotFoundButtons = props => {
  const { handleBtnClick } = props;

  return (
    <>
      <LargeButton
        subText='See the industry baseline view'
        onClick={() => handleBtnClick('/industry-reports/baseline')}>
        Baseline
      </LargeButton>
      <LargeButton
        subText='Create a custom report'
        onClick={() => handleBtnClick('/industry-reports/customization')}>
        Appraisal View
      </LargeButton>
      <LargeButton
        subText='View available VIP resources'
        onClick={() => handleBtnClick('/resources#search-resources')}>
        Resources
      </LargeButton>
    </>
  );
};

export default IndustryOnlyNotFoundButtons;
